function initSwiper({
  swiperSelector,
  swiperOptions = {},
  autoplayResumeDelay = 0
}) {
  const sw = typeof swiperSelector === 'string'
    ? document.querySelector(swiperSelector)
    : swiperSelector;

  if (!sw) return null;

  if (sw.swiper && !sw.swiper.destroyed) {
    destroySwiper(sw);
  }

  const swiper = new Swiper(sw, {
    speed: 500,
    observer: true,
    observeParents: true,
    ...swiperOptions,
  });

  if (autoplayResumeDelay > 0 && swiper.autoplay) {
    initSwiperAutoplayResume(swiper, autoplayResumeDelay);
  }

  return swiper;
}


function initSwiperAutoplayResume(swiper, delay) {
  const el = swiper.el;

  let timer;
  let hovered = false;

  const pause = () => {
    clearTimeout(timer);

    if (!swiper.destroyed && swiper.autoplay.running) {
      swiper.autoplay.pause();
    }
  };

  const resume = () => {
    clearTimeout(timer);

    if (hovered || swiper.destroyed) return;

    timer = setTimeout(() => {
      if (hovered || swiper.destroyed) return;

      swiper.autoplay.running
        ? swiper.autoplay.resume()
        : swiper.autoplay.start();
    }, delay);
  };

  const enter = () => {
    hovered = true;
    pause();
  };

  const leave = () => {
    hovered = false;
    resume();
  };

  swiper.on('touchStart', pause);
  swiper.on('touchEnd', resume);

  el.addEventListener('mouseenter', enter);
  el.addEventListener('mouseleave', leave);

  swiper.on('destroy', () => {
    clearTimeout(timer);
    el.removeEventListener('mouseenter', enter);
    el.removeEventListener('mouseleave', leave);
  });
}


function hiddenSlides(swiper) {
  const isMobile = window.innerWidth < 800;
  const indexRemove = [];

  swiper.slides.forEach((slide, index) => {
    const hideOnMobile = slide.dataset.hideMobile === 'true';
    const hideOnDesktop = slide.dataset.hideDesktop === 'true';

    if (
      (isMobile && hideOnMobile) ||
      (!isMobile && hideOnDesktop)
    ) {
      indexRemove.push(index);
    }
  });

  if (!indexRemove.length) return;

  swiper.removeSlide(indexRemove);
  swiper.update();
}


function destroySwiper(sw) {
  if (!sw?.swiper || sw.swiper.destroyed) return null;

  sw.swiper.destroy(true, true);

  return null;
}

/* Handle tabmenu builder */
function initTabMenuBuilder(root) {
  const activeClass = 'is-active';
  if (typeof root === 'string') root = document.querySelector(root);
  if (!root) return;

  const getButtons = () => [
    ...root.querySelectorAll('[data-tab-heads] .button-style')
  ];

  const getPanels = () => [
    ...root.querySelectorAll('[data-tab-panel]')
  ];

  const activate = (index) => {
    const buttons = getButtons();
    const panels = getPanels();

    buttons.forEach((button, i) => {
      button.classList.toggle(activeClass, i === index);
    });

    panels.forEach((panel, i) => {
      panel.classList.toggle(activeClass, i === index);
      panel.hidden = i !== index;
    });
  };

  if (root.dataset.tabBuilderBound !== 'true') {
    root.dataset.tabBuilderBound = 'true';

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-tab-heads] .button-style');
      if (!button || !root.contains(button)) return;

      if (button.tagName === 'A') event.preventDefault();

      const buttons = getButtons();
      const index = buttons.indexOf(button);

      if (index >= 0) activate(index);
    });
  }

  root.__activateTabMenu = activate;

  if (root.dataset.tabBuilderBound !== 'true') {
    root.dataset.tabBuilderBound = 'true';

    root.addEventListener('click', (event) => {
      const button = event.target.closest('.button-style');
      const headWrap = root.querySelector('[data-tab-heads]');

      if (!button || !headWrap || !headWrap.contains(button)) return;

      event.preventDefault();

      const index = getButtons().indexOf(button);
      if (index >= 0) activate(index);
    });
  }

  activate(0);
}

/* Handle tabmenu builder 1.1 */
function syncTabButtonHeads(root) {
  const activeClass = 'is-active';

  if (typeof root === 'string') root = document.querySelector(root);

  if (!root) return;

  const getElements = (selector) =>
    [...root.querySelectorAll(selector)].filter(
      (el) => el.closest('[data-tab-menu]') === root
    );

  const head = getElements('[data-tab-heads]')[0];
  const panels = getElements('[data-tab-panel]');

  if (!head || !panels.length) return;

  const buttonMap = new Map(
    getElements('[data-tab-btn]').map((button) => [
      button.dataset.tabId,
      button
    ])
  );

  /* Collection all buttons to head */
  panels.forEach((panel) => {
    const button = buttonMap.get(panel.dataset.tabId);
    if (button) head.append(button);
  });

  const activate = (tabId) => {
    getElements('[data-tab-btn]').forEach((button) => {
      const active = button.dataset.tabId === tabId;

      button.classList.toggle(activeClass, active);
      button
        .querySelector('.button-style')
        ?.classList.toggle(activeClass, active);
    });

    getElements('[data-tab-panel]').forEach((panel) => {
      panel.classList.toggle(
        activeClass,
        panel.dataset.tabId === tabId
      );
    });

    root.dataset.activeTabId = tabId;
  };

  if (!root.dataset.tabBound) {
    root.dataset.tabBound = 'true';

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-tab-btn]');

      if (!button || !head.contains(button)) return;

      event.preventDefault();
      activate(button.dataset.tabId);
    });
  }

  const firstTabId = panels.find((panel) =>
    buttonMap.has(panel.dataset.tabId)
  )?.dataset.tabId;

  activate(root.dataset.activeTabId || firstTabId);
}